import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StripeService, Elements, Element as StripeElement, ElementsOptions} from 'ngx-stripe';
import {markFormGroupTouched} from '../../global';
import {first} from 'rxjs/operators';
import {CustomerService} from '../../services/customer.service';
import {SharedService} from '../../services/shared.service';
import {CardModel} from '../../models/card.model';


@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.scss']
})
export class PaymentDialogComponent implements OnInit {
  title: string = 'PAYMENTTEXT';
  addCardForm: FormGroup;
  elements: Elements;
  elementsOptions: ElementsOptions = {locale: 'en'};
  card: StripeElement;
  zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
  showAddCardForm: boolean;
  cards: Array<any> = [];
  defaultCard: string;
  showLoader: boolean;
  data: any;

  constructor(public dialogRef: MatDialogRef<PaymentDialogComponent>,
              private fb: FormBuilder,
              private shared: SharedService,
              private stripeService: StripeService,
              private customerService: CustomerService,
              @Inject(MAT_DIALOG_DATA) data) {
    this.data = data;
    this.addCardForm = fb.group({
      name: [null, Validators.required],
      address_line1: [null, Validators.required],
      address_line2: [null],
      address_zip: [null, Validators.required],
      address_city: [null, Validators.required],
      address_state: [null, Validators.required],
      address_country: ['US', Validators.required]
    });
  }

  ngOnInit() {
    this.stripeService.elements(this.elementsOptions)
      .subscribe(elements => {
        this.elements = elements;
        if (!this.card) {
          this.card = this.elements.create('card', {
            hidePostalCode: true,
            style: {
              base: {
                iconColor: '#666EE8',
                color: '#31325F',
                lineHeight: '30px',
                fontWeight: 300,
                fontFamily: '"Roboto", sans-serif',
                fontSize: '16px',
                '::placeholder': {
                  color: '#CFD7E0'
                }
              }
            }
          });
          this.card.mount('#card-element');
          this.showAddCardForm = this.data && this.data.cardFrom;
        }
      });
    this.refreshCards();
  }

  refreshCards() {
    this.showLoader = true;
    this.customerService.getStripeAccountInfo()
      .then(accountInfo => {
        this.cards = [];
        this.defaultCard = accountInfo['default_source'];
        let sources = accountInfo['sources']['data'] || [];
        sources.forEach(source => {
          if(source.object == 'card') this.cards.push(new CardModel(source));
          if(source.object == 'source' && source.type == 'card') this.cards.push(new CardModel(source.card, source.id));
        });
        this.showLoader = false;
      })
      .catch(res => {
        this.showLoader = false;
        this.shared.openErrorDialog({title: 'Payment error', body: 'Error loading payment information. Please try again.'});
      });
  }

  addCard(form: FormGroup) {
    markFormGroupTouched(this.addCardForm);
    if (form.valid) {
      this.showLoader = true;
      let data = form.value;
      if (!data.address_line2 || data.address_line2.length == 0) delete data.address_line2;
      this.stripeService
        .createToken(this.card, data)
        .pipe(first())
        .toPromise()
        .then(result => {
          if (result.token) {
            return this.customerService.createSource({type: 'card', token: result.token.id});
          } else if (result.error) {
            return Promise.reject(result.error);
          }
        })
        .then(res => {
          return this.customerService.addSourceToAccount(res.source.id);
        })
        .then(res => {
          this.setDefaultCard(res.source.id);
          this.showAddCardForm = false;
          this.card.clear();
          this.addCardForm.reset();
        })
        .catch(res => {
          this.showLoader = false;
          let err = res.error || res;
          let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
          this.shared.openErrorDialog(error);
        });
    }
  }

  setDefaultCard(cardId: string) {
    this.showLoader = true;
    this.customerService.updateStripeInformation({default_source: cardId})
      .then(_ => {
        this.showLoader = false;
        this.dialogRef.close();
      })
      .catch(res => {
        this.showLoader = false;
        let err = res.error || res;
        let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
        this.shared.openErrorDialog(error);
      });
  }

  deleteCard(cardId: string) {
    this.showLoader = true;
    this.customerService.deleteCardFromAccount(cardId)
      .then(_ => {
        this.showLoader = false;
        this.refreshCards();
      })
      .catch(res => {
        this.showLoader = false;
        let err = res.error || res;
        let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
        this.shared.openErrorDialog(error);
      });
  }

  cancelForm() {
    this.addCardForm.reset();
    if (this.data && this.data.cardFrom) this.dialogRef.close();
    else this.showAddCardForm = false;
  }


}
